/* eslint-disable no-use-before-define */
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

import { updateCompanyId } from '../../../../../redux/actions/userActions';
import { userService } from '../../../../../services/napoleon';
import companyService from '../../../../../services/napoleon/CompanyService';
import useToastActions from '../../../../../redux/actions/useToastActions';
import { REGISTER_STEPS } from '../../../../../constants/registerSteps';
import { ButtonComponent, ErrorState, Loading } from '../../../../../components';
import { SelectInput } from '../../../../../components/Form';
import styles, { FormContainer, Footer } from '../../styles';
import { errorMessages } from './helpers';
import useFormStep from './useFormStep';
import StepsHeadline from './StepsHeadline';

const formStep = REGISTER_STEPS.COLLABORATORS;

export default function NumberOfCollaborators({
  handleBack,
  handleNext,
  collaboratorSizeRange,
  isFetchingData,
  isError,
}) {
  const { error } = useToastActions();
  const { authByGoogle } = useSelector((state) => state.registerStepReducer);
  let { companyId } = useSelector((state) => state.registerStepReducer);
  const email = useSelector(
    (state) => state.registerStepReducer.steps[REGISTER_STEPS.SIGN_IN_INFO]?.email,
  );

  async function updateCompanyNumberOfCollaborator() {
    const selected = collaboratorSizeRange.find(
      (range) => range.label === form.collaboratorSizeRangeLabel,
    );

    try {
      if (!companyId) {
        const response = await userService.findDataUserByEmail(
          !authByGoogle ? authByGoogle.email : email,
        );
        companyId = response.data.companyId;
        useDispatch(updateCompanyId(companyId));
      }
      await companyService.update({ collaboratorSizeRangeId: selected.id, id: companyId });

      handleNext();
    } catch (err) {
      error('Erro ao tentar atualizar dados. Tente novamente mais tarde.');
    }
  }

  const validateField = (name, value) => {
    if (!value?.trim()) return errorMessages.MANDATORY_FIELD;
    return '';
  };

  const {
    form, formErrors, isLoading, handleChange, handleSubmit, updateRedux, isStepValid,
  } = useFormStep(formStep, validateField, updateCompanyNumberOfCollaborator);

  if (isFetchingData) return <Loading />;

  if (isError && !isFetchingData) {
    return <ErrorState msg="Erro ao buscar informações. Tente novamente mais tarde." />;
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <StepsHeadline />

      <FormControl sx={styles.textField} variant="standard">
        <SelectInput
          id="simple-select-standard"
          value={form.collaboratorSizeRangeLabel}
          name="collaboratorSizeRangeLabel"
          onChange={handleChange}
          placeholder="Número de colaboradores"
          error={!!formErrors.collaboratorSizeRangeLabel}
          helperText={formErrors.collaboratorSizeRangeLabel}
          sx={styles.stateField}
        >
          {collaboratorSizeRange.map((range) => (
            <MenuItem value={range.label} key={range.id.toString()}>
              {range.label}
            </MenuItem>
          ))}
        </SelectInput>
      </FormControl>

      <Footer style={styles.registerStepsFooter}>
        <ButtonComponent
          size="small"
          variant="outlined"
          disabled={isLoading}
          onClick={() => {
            updateRedux();
            handleBack();
          }}
        >
          Voltar
        </ButtonComponent>

        <ButtonComponent
          type={isLoading ? 'button' : 'submit'}
          size="small"
          disabled={!isStepValid() || isLoading}
          loading={isLoading}
        >
          Próximo
        </ButtonComponent>
      </Footer>
    </FormContainer>
  );
}

NumberOfCollaborators.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  collaboratorSizeRange: PropTypes.array,
  isFetchingData: PropTypes.bool,
  isError: PropTypes.bool,
};
